import BackroundGradient from "./common/BackroundGradient.component";
import add from '../../assets/htbd-images/add.png';

function Grading() {
  return (
      <section className="container-fluid p-5 position-relative">
      <BackroundGradient />
        <h1 className="text-white text-center">
          Grading <strong style={{ color: "#7e56d8" }}>Criteria</strong>
        </h1>
        <div className="container-fluid p-5 position-relative">
          <div className="row justify-content-evenly text-center">
            <div className="col-lg-2">
              <div className="p-3" style={{ backgroundColor: "#7e56d8" }}>
                <h3>Pass</h3>
                <p className="text-white">
                  You will achieve this grade with a total score range of 5 - 15 marks.
                </p>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="p-3" style={{ backgroundColor: "#7e56d8" }}>
                <h3>Merit</h3>
                <p className="text-white">
                  You will achieve this grade with a total score range of 16 - 25 marks.
                </p>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="p-3" style={{ backgroundColor: "#7e56d8" }}>
                <h3>Distinction</h3>
                <p className="text-white">
                  You will achieve this grade with a total score range of 26 - 35 marks.
                </p>
              </div>
            </div>
          </div>
          <span className="position-absolute bottom-0 translate-middle-x" style={{ zIndex: -1, right:'0%' }}>
          <img src={add} alt="add" />
        </span>
        </div>

        <div className="row justify-content-md-center g-5">
          <div className="col-lg-10">
            <div
              className="border border-light rounded-5 p-3 h-100"
              style={{ backgroundColor: "#f39322" }}
            >
              <h3 className="text-dark">Academic Policies</h3>
              <ul className="text-white">
                <li style={{ listStyle: "circle" }}>
                  Be thrilled about the environment and facilities you see in
                  Dubai, though failing to attend that one live session on IBP
                  could be chilling and could affect your grades.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Be thrilled about weekly agendas, these are set and ready for
                  you to have a smooth ride through the course. However, failing
                  to complete your MCQs and reflections will downgrade your
                  final grade.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Your reflections should be your own and avoid any act of
                  plagiarism in your submission.
                </li>
                <li style={{ listStyle: "circle" }}>
                  You can access the course only for 5 weeks from the date of
                  start (allotment of your ID). You cannot edit your answer once
                  submitted.
                </li>
                <li>
                  Your learning will be of three kinds: asynchronous, Live
                  sessions, and virtual field visits.
                </li>
                <li style={{ listStyle: "circle" }}>
                  For any queries related to academic policies and
                  clarifications feel free to reach: bem@seedingbrains.com / Mob
                  +971529607869
                </li>
                <li style={{ listStyle: "circle" }}>
                  Office hours are between 10:00 am — 5:00 pm Monday to Friday.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
  );
}

export default Grading;
